module.exports = __webpack_public_path__ + "img/freeSupport.96d66d3.svg";